import React, { useRef } from "react";
import { FileSelector } from "../../form/Dropzone";
import { Icon } from "../../graphic/Icon";
import { Clickable } from "../Clickable";
import style from "./style.scss";

export const Adder = ({ onClick, onFileSelect, link, label, multiple, accept }) => {
    const fileSelectorRef = useRef();

    const handleClick = () => {
        if (onClick) {
            onClick();
        } else if (onFileSelect) {
            fileSelectorRef.current.open();
        }
    };

    return (
        <Clickable className={style.base} onClick={handleClick} link={link}>
            <div className={style.content}>
                <div className={style.icon}>
                    <Icon name="plus" />
                </div>
                {label ? <div className={style.label}>{label}</div> : null}
            </div>

            {onFileSelect ? (
                <FileSelector ref={fileSelectorRef} onSelect={onFileSelect} multiple={multiple} accept={accept} />
            ) : null}
        </Clickable>
    );
};
